import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/conditions/[title]/page.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/img/therapist-1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/img/therapist-2.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/img/therapist-3.jpeg");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/vercel/path0/src/components/Articles/ShareButtons.tsx");
